// Generated by scripts/build-releases.js from releases/published/*.md. Do not edit.
export const RELEASES = [
    {
        "id": "2026-10-26-1.12.0",
        "title": "2026-10-26-1.12.0",
        "version": "",
        "date": "",
        "blocks": [
            {
                "type": "p",
                "text": "title: Efficient chat for chosen districts, and a say on which districts’ logo and tagline chat puts on its documents version: 1.12.0 date: 2026-10-26 email: no emailed: ---"
            },
            {
                "type": "p",
                "text": "**What's new.**"
            },
            {
                "type": "ul",
                "items": [
                    "**Efficient chat for chosen districts and users.** Admin → **Efficient chat** is a new tile for choosing who gets lower-cost chat. A cheaper model does the data work behind an answer, and the usual model still writes every answer, so users see the same voice. In testing on real district questions it cost 40 to 60% less at the same response time. Add a district and leave **All users** on, or turn it off and pick individual people. Removing someone switches them back from their next message. Anyone not on the list keeps chat exactly as today.",
                    "**Districts’ own colors on the documents chat builds.** The workbooks, reports, decks and charts chat builds now carry each district’s own colors from its profile. The district’s logo and tagline stay off until someone has looked at them.",
                    "**Decide per district.** Admin → **District looks** lists every district with its colors, logo and tagline, a preview of a document header, and three switches: Colors, Logo, Tagline. Flip one and it applies from that district’s next chat file or chart, within a minute. The row shows who reviewed it and when."
                ]
            },
            {
                "type": "p",
                "text": "**What to do.** Check your districts’ logo and tagline on District looks and switch them on where they are right. Wrong colors or logo are fixed in the district’s profile, not here. Nothing changes in how you work otherwise."
            },
            {
                "type": "p",
                "text": "**Good to know.** Efficient chat applies to Claude-model chats only, not the dashboard builder. Both pages are for superusers for now. Colors can be switched off per district if a profile’s colors are wrong."
            }
        ]
    },
    {
        "id": "2026-10-21-1.11.0",
        "title": "Every customer email as work, meetings that know who matters, activation at a glance, and a faster portal",
        "version": "1.11.0",
        "date": "2026-10-21",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.**"
            },
            {
                "type": "ul",
                "items": [
                    "**Email with a district, wherever you look.** Client Overview → Key Dates & Timeline → **Email** reads the shared inboxes (ops@, support@, implementations@) and shows every thread with its Outlook tags. Every thread is a work item under the new **Email** system on Client Work and Work overview; its status is its Outlook tag. Click the subject or **Read** on any row to read it in place, as it looks in Outlook.",
                    "**Mark who matters in a meeting.** Star an attendee as Important and keep notes on them, for that meeting or for the person wherever they appear. Under each district attendee: last active and actions in the last 30 days, or \"no Nexus account\".",
                    "**CS journey dates in one pick.** Key Dates & Timeline → Add date now offers the CS Playbook's meetings (Kickoff, Wave 1 Review, Training, Close Meeting, Quarterly Review, and the on-request ones) with a proposed date counted from the kickoff date or the previous meeting, logged or captured from the calendar. Change anything before saving. Admin → Work Settings → CS journey shows the list as a flow.",
                    "**See which districts aren't activating.** Four Activation tiles sit beside the Needs tiles on Client Overview: the share of districts using 75%+ of their seats, where 75%+ of users ask questions, go 3+ questions deep, and open dashboards. Blue is the last 30 days, cyan the 30 before. Click a tile to list the districts below the line with each one's own numbers. Settings sets the window and the lines for the team. Help → \"Find districts that aren't activating\" walks through it.",
                    "**Ask the Assistant about any of it.** Email threads and what was said, work item notes and links, meeting notes and attendee marks, the Needs chips, Ready for me, Cost of work, district reports, the roadmap, alert send status and the CS journey.",
                    "**Faster everywhere.** Pages open sooner and come back instantly; Meetings no longer waits half a minute. Each page now loads only its own code."
                ]
            },
            {
                "type": "img",
                "src": "/release-media/feat-4338-email-lane.png",
                "alt": "The Email section on Client Overview: two threads, each with its status chip, who wrote, and an Outlook link"
            },
            {
                "type": "img",
                "src": "/release-media/feat-4338-email-reader.png",
                "alt": "A thread open in the reader: the district's message with bold text and a list, our reply below it, Open in Outlook at the top"
            },
            {
                "type": "img",
                "src": "/release-media/feat-4340-attendee-notes.png",
                "alt": "Who was there on a meeting: Dana starred as Important with a kept note, and the line \"active 3d ago · 23 actions\" under her name"
            },
            {
                "type": "img",
                "src": "/release-media/feat-4334-activation-tiles.png",
                "alt": "Client Overview with the Needs and Activation tiles side by side; Chat activation clicked, listing two districts with their own counts for both periods"
            },
            {
                "type": "img",
                "src": "/release-media/feat-assistant-coverage.png",
                "alt": "The Assistant answering \"What's open with Demo ISD by email?\" with two threads, their status and who wrote last"
            },
            {
                "type": "p",
                "text": "**What changes for you.** Cc a shared inbox: mail that never reaches one is not here. Resolve a thread here or tag it **Resolved** in Outlook; same tag."
            },
            {
                "type": "p",
                "text": "**Good to know.** Mail is read hourly. \"Waiting…\" tags show as blocked. Resolve from the portal works now; the Outlook tag follows once a permission lands, and the thread says so until then. Attendee marks never reach Outlook. Nexus staff are not scored. The journey dropdown proposes; it never schedules. Activation's earlier period uses today's seat holders."
            }
        ]
    },
    {
        "id": "2026-10-18-1.10.0",
        "title": "See whether each alert went out",
        "version": "1.10.0",
        "date": "2026-10-18",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Every alert now shows whether its last scheduled email went out: **Sent**, **Partial 5/6**, **Failed**, **Missed** or **Sending…**, plus when it last sent and when it sends next. Click the status to see recent sends, who got each one, and why a send failed."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Admin → Alerts, and a client's **Alerts** tab in Client Overview. On Admin → Alerts, the **Needs attention** chip shows only failed, missed and partial alerts."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work."
            },
            {
                "type": "p",
                "text": "**Good to know.** Tracking starts when this goes live, so older alerts show **No sends yet** until their next send. Alerts still set up in a file show **Not tracked yet**."
            }
        ]
    },
    {
        "id": "2026-10-13-1.9.1",
        "title": "The client list's Needs load at once",
        "version": "1.9.1",
        "date": "2026-10-13",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** The Needs tiles and chips on Client Overview → Clients no longer sit on \"…\" for up to a minute. The list shows the last reading straight away and refreshes it in the background."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Client Overview → Clients. Beside the client count, \"needs as of\" says when the chips were read; \"updating\" means a fresh reading is on its way."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work."
            },
            {
                "type": "p",
                "text": "**Good to know.** A reading is at most 5 minutes old, or up to an hour if nobody has opened the list for a while."
            }
        ]
    },
    {
        "id": "2026-10-13-1.9.0",
        "title": "Edit what you wrote, see who needs you, and new work finds its owner",
        "version": "1.9.0",
        "date": "2026-10-13",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.**"
            },
            {
                "type": "ul",
                "items": [
                    "**Edit a to-do from anywhere, and move it to another client.** Every to-do row has a pencil after Resolve; it opens one form, client included. Every row shows its client's name.",
                    "**Fix a typo after you post.** Edit your own notes: work item updates, to-do notes, request updates, meeting notes. Edited notes say \"edited\" and keep earlier versions. Nothing can be deleted.",
                    "**New work goes to the right person.** Leave Owner blank on Create work item and it goes to the client's integration owner; the form shows who. Your pick wins.",
                    "**A calmer Create work item form**, on one page, with a live preview. Priority, Requested by and Stakeholders sit under **More detail**.",
                    "**See who needs attention.** Client Overview → Clients has a **Needs** column: overdue work, usage down 30%+, no contact in 30 days, renewal within 90 days. **Integrations** reads \"3 of 5 active\".",
                    "**Email counts as contact.** Human email in ops@, support@ and implementations@ counts toward last contact, and each client's Key Dates & Timeline has a collapsed **Email** section.",
                    "**Key dates on Meetings.** Tick **Show in Meetings Calendar** on a key date.",
                    "**Roadmaps for every team**, and DevOps rows name their board area.",
                    "File a bug puts the bug on the roadmap. District report shows **What reports have cost**. Assistant settings survive signing out. \"Are you sure?\" boxes no longer freeze the tab. Help videos are refreshed."
                ]
            },
            {
                "type": "p",
                "text": "**What changes for you.** Put the district person in **Client owner (district)**. \"Check in with\" is now Nexus / Client / Other."
            },
            {
                "type": "p",
                "text": "**Good to know.** Client owners are never emailed. Anything that can't be read says so, never 0."
            }
        ]
    },
    {
        "id": "2026-10-01-1.8.1",
        "title": "Work rows show when access arrived",
        "version": "1.8.1",
        "date": "2026-10-01",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** DevOps rows now carry small tags when a district or vendor said so: **Access granted 3d ago**, **Credentials shared 1d ago**, **Data ready 5d ago**."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Any work item row (Work overview, a client's Work tab, under a meeting). Click a tag to open Ready for me."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work. The tags show what Ready for me already knows, right on the row."
            },
            {
                "type": "p",
                "text": "**Good to know.** Only Patrick, Eric and Walker see them. They come from implementations@ and ops@, and the ticket match is the model's guess; hover a tag to see it."
            }
        ]
    },
    {
        "id": "2026-10-01-1.8.0",
        "title": "See which tickets you can start now",
        "version": "1.8.0",
        "date": "2026-10-01",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Ready for me lists the open DevOps tickets where a district or vendor has said access or data arrived — an account created, a feed scheduled, credentials or files sent — newest first, with their words and a link to the email. Patrick and Eric also get an email the moment one lands."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Work overview → **Ready for me** chip (Patrick, Eric and Walker)."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Copy implementations@ on access and data emails, or forward them there."
            },
            {
                "type": "p",
                "text": "**Good to know.** It reads implementations@ and ops@ only, never board columns. A claim, not a check: log in before you build. The ticket match is the model's guess and says so."
            }
        ]
    },
    {
        "id": "2026-09-30-1.7.0",
        "title": "District report: change anything, fuller counts",
        "version": "1.7.0",
        "date": "2026-09-30",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Change anything in a district report: any wording, heading, number or table, and turn any section or item off. Counts now use **questions**, include dashboard chats, credit every data source used, and break each area of work into finer subcategories. One **Time working in Nexus** figure covers everything."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Admin → **District report** → open a report. Click any text, point at a table or heading, or use **Sections and items**."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Regenerate a report to see the fuller numbers. **Estimated time returned** now counts every file made and adds working time, so it is higher."
            },
            {
                "type": "p",
                "text": "**Good to know.** Reading a page without clicking counts once portal tracking goes live."
            }
        ]
    },
    {
        "id": "2026-09-29-1.6.0",
        "title": "District report: exact dates, clearer options, everyone who used Nexus",
        "version": "1.6.0",
        "date": "2026-09-29",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Pick exact dates for a district report. **Staff using Nexus** now counts everyone who used Nexus in any way (chat, dashboards, saved tools), once each, with a breakdown under the number. The staff table gains **Dashboards** and **Saved tools** columns."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Admin → **District report** → Period → **Exact dates**. **More options** is now grouped into *What to include* and *How highlights read*, with an example of each highlight style."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Highlight styles are now called **Story** and **Short**."
            },
            {
                "type": "p",
                "text": "**Good to know.** Where Nexus didn't record dashboard and tool activity for nearly everyone, the report counts chat only and says **Staff using chat**. The state comparison still counts chat only."
            }
        ]
    },
    {
        "id": "2026-09-28-1.5.1",
        "title": "Release notes now come with pictures",
        "version": "1.5.1",
        "date": "2026-09-28",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Notes on this page can now show a screenshot of the change they describe. Here is the one from 1.5.0: the thank-you after filing a bug, which now says where the bug went, who owns it and when it's due."
            },
            {
                "type": "img",
                "src": "/release-media/feat-sp-150-verified.png",
                "alt": "The File a bug thank-you: filed to the Super Portal board's Inbox, owned by patrick@asknexus.ai, due Mon, Oct 5, you're listed as a stakeholder"
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work."
            },
            {
                "type": "p",
                "text": "**Good to know.** File a bug and meeting notes were checked on the live portal after 1.5.0 went out, with test items that were cleaned up afterwards."
            }
        ]
    },
    {
        "id": "2026-09-28-1.5.0",
        "title": "Meeting notes, and nudges that know due dates",
        "version": "1.5.0",
        "date": "2026-09-28",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Add notes to a meeting. Nudges now include anything on or past its due date, even with no priority. Filed bugs say who owns them and when they're due. Work overview shows integrations work only, unless you ask for Super Portal work."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Any meeting → **Notes**. Work overview → **Show Super Portal work**. **File a bug** → the thank-you."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Overdue items return in your nudge daily until closed or re-dated; a note quiets them for that day."
            },
            {
                "type": "p",
                "text": "**Good to know.** Anyone on Meetings reads notes; you remove only your own. Super Portal rows carry a **Super Portal** label."
            }
        ]
    },
    {
        "id": "2026-09-28-1.4.0",
        "title": "Show a district what Nexus did for them",
        "version": "1.4.0",
        "date": "2026-09-28",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Build a report for a district: who used Nexus, what they worked on, highlights of what they built, the data sources behind it, progress toward the district's own goals, and optionally how it compares with other districts in its state. You see the cost before you create it."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Admin → **District report**. Pick a district, choose a period, then **Create report**."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work. To share one, open it, click any sentence to change the wording, approve it, then **Download PDF**."
            },
            {
                "type": "p",
                "text": "**Good to know.** Pilot. A dotted underline marks wording written by Claude, so read those before approving. Until a report is approved, its PDF says DRAFT."
            }
        ]
    },
    {
        "id": "2026-09-25-1.3.0",
        "title": "Meetings now appear within the hour",
        "version": "1.3.0",
        "date": "2026-09-25",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Meetings appear within the hour: calendars are read hourly. A **How meetings are found** panel explains whose calendars are read, what counts, and when. Unplaced school domains show the district's name, and clicking one lists your own meetings with it. Busy month days scroll."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Meetings → **Show details** at the top, and the domain list below."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Suggested answers (dashed chips) take one click, and prospect districts clear in one go. Only school districts are listed. Others are counted, never named. Titles show only to whoever's calendar it was, plus Patrick, Luke, Riley and Walker."
            },
            {
                "type": "p",
                "text": "**Good to know.** Suggestions never apply themselves. A district name is not a client."
            }
        ]
    },
    {
        "id": "2026-09-24-1.2.0",
        "title": "Ask the Assistant what happened to any item",
        "version": "1.2.0",
        "date": "2026-09-24",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** The Super Assistant can now answer \"who touched this item?\" and \"what changed on Hutto's work this week?\" It sees every create, assign, update, link, resolve and reopen made from the portal, and knows which client's page you're on. The Migration Queue on Implementations loads again, and the Integration Hub lists each vendor filed under \"Other\" separately, each with its own schema notes."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Ask the Super Assistant, for example: \"What happened to the Satsuma to-dos today?\" Implementations → Migration Queue; Implementations → Integration Hub."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work."
            },
            {
                "type": "p",
                "text": "**Good to know.** Assistant history starts today; changes made directly in DevOps or Monday aren't included. Clicks and searches on work pages are recorded, never note text. Across Customer Success, Client Wins and Implementations, a panel that can't read its data now says so instead of showing nothing."
            }
        ]
    },
    {
        "id": "2026-09-23-1.1.0",
        "title": "See what changed, right in the portal",
        "version": "1.1.0",
        "date": "2026-09-23",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** Every Super Portal update now comes with a short note like this one: what changed, where to find it, and whether anything changes for you. The notes live in the portal, so you can catch up whenever you like."
            },
            {
                "type": "p",
                "text": "**Where to find it.** Click the megaphone icon in the top bar, next to the **?**. A small red dot on the megaphone means there's a note you haven't read yet."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Nothing changes in how you work."
            },
            {
                "type": "p",
                "text": "**Good to know.** Notes only appear once a change is live. Anything still being built stays out until it ships."
            }
        ]
    },
    {
        "id": "2026-09-23-1.0.0",
        "title": "All your client work, in one place",
        "version": "1.0.0",
        "date": "2026-09-23",
        "blocks": [
            {
                "type": "p",
                "text": "**What's new.** DevOps tickets, technical outreach requests, client to-dos and implementation requests now show up together, and every item reads the same way. Each row shows its state, owner, who asked for it, stakeholders, priority, deadline, and any meeting it's tied to. Every row has the same six buttons: Create, Assign, Update, Link, Resolve, Reopen."
            },
            {
                "type": "p",
                "text": "**Where to find it.** There are three places:"
            },
            {
                "type": "ul",
                "items": [
                    "**Client overview → Client Work** shows one client's work.",
                    "**Work overview** shows everyone's work, and exports to Excel.",
                    "**Meetings** shows what's due before each client meeting."
                ]
            },
            {
                "type": "p",
                "text": "To file anything, use **Create work item** at the top of a client."
            },
            {
                "type": "p",
                "text": "**What changes for you.** Post an **Update** on items you own. Your update shows up in DevOps, Monday or the to-do itself, so there's no double entry."
            },
            {
                "type": "p",
                "text": "**Good to know.** Short how-to videos live under the **?** icon. Found something off? Use **File a bug** (bottom left). It goes straight to Patrick."
            }
        ]
    }
];
